
import { computed, defineComponent, inject } from 'vue';
import { useStore } from 'vuex';
import { UAParser } from 'ua-parser-js';
import useCookies from './lib/useCookies';

export default defineComponent({
    setup() {
        const store = useStore();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const gtag = inject<any>('gtag');
        const { showBanner, okClicked } = useCookies(gtag);

        const isNotificationMessage = computed(() => store.getters['ui/isNotificationMessage']);

        const isAllowedSubscriptions = computed(() => {
            if (store.getters['auth/userSettingString']('allowSubscriptions') === 'True') {
                return true;
            } else {
                return false;
            }
        });

        const okBannerClicked = () => {
            okClicked();
        };

        const closeNotificationMessage = (): void => {
            store.commit('ui/closeNotificationMessage');
        };

        const isOs = computed(() => {
            const parser = new UAParser();
            if (parser.getOS().name.toLowerCase().includes('ios')) {
                return true;
            } else {
                return false;
            }
        });

        return {
            isOs,
            showBanner,
            isNotificationMessage,
            isAllowedSubscriptions,
            okBannerClicked,
            closeNotificationMessage,
        };
    },
});
